import useRepaymentInfoBottomSheet from '../../../application/hooks/useRepaymentInfoBottomSheet';
import { ReactElement, useEffect } from 'react';
import { Bottomsheet } from 'oui';
import RateCalculator from '../../etc/RateCalculator/RateCalculator';
import RepaymentInfoBottomSheet from '../RepaymentInfoBottomSheet/RepaymentInfoBottomSheet';

interface IRateCalcBottomSheet {
  isShow: boolean;
  handleClickOpenBottomSheet: () => void;
  handleClickCloseBottomSheet: () => void;
  preset?: {
    amount?: string;
    interestRate?: string;
    term?: string;
    maxTerm?: number;
  };
  contentsList?: ReactElement;
}

const RateCalcBottomSheet = ({
  isShow,
  handleClickCloseBottomSheet,
  preset,
}: IRateCalcBottomSheet) => {
  const {
    openInfoBottomSheet,
    handleClickOpenInfoBottom,
    handleClickCloseInfoBottom,
  } = useRepaymentInfoBottomSheet();

  //todo 임시 적용 - 리팩토링
  useEffect(() => {
    const { body } = document;
    if (isShow) {
      body.style.overflow = 'hidden';
    } else if (openInfoBottomSheet) {
      body.style.overflow = 'hidden';
    } else {
      body.style.overflow = '';
    }
  }, [openInfoBottomSheet, isShow]);

  return (
    <Bottomsheet
      isOpen={isShow}
      onClose={handleClickCloseBottomSheet}
      disableScrollLock={true}
      backdrop={true}
      children={
        <>
          <RateCalculator
            isBottomSheet={true}
            onIconClick={handleClickCloseBottomSheet}
            onInfoIconClick={handleClickOpenInfoBottom}
            preset={preset}
          />
          <RepaymentInfoBottomSheet
            isShow={openInfoBottomSheet}
            handleClickCloseInfoBottom={handleClickCloseInfoBottom}
            isBottomSheet={true}
          />
        </>
      }
    />
  );
};

export default RateCalcBottomSheet;
